import {
  NitroDrawer,
  NitroContentNotAvailable,
  NitroLoading,
  NitroButtonGroup,
  NitroButton,
  NitroText
} from 'nitro-components';

import EnhancedTextarea from 'material-ui/TextField/EnhancedTextarea';

import React, { Component, PropTypes } from 'react';

import DataProvider from '../dataProvider';
import { SidePanelHeader } from '../../../components/factoryComponents';

import styled from 'styled-components';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

// TODO -SRIRAM - NOT HAPPY WITH THE WAY MATERIAL UI TEXT AREA IS BEING USED .. NEED TO LOOK INTO CREATING NITRO COMPONENT FOR TEXT AREA
const notesTextAreaStyles = {
  width: '100%',
  resize: 'none',
  overflow: 'hidden',
  font: 'inherit',
  marginBottom: '10px',
  borderColor: '#e6e6e6',
  borderRadius: '4px',
  fontSize: '14px',
  outline: 'none',
  padding: '13px',
  color: '$color-base-3'
};

const NoteInputContainer = styled.div`
  margin-top: 20px;
`;

const NotesListContainer = styled.section`
  padding: 8px;
  margin-top: 30px;
`;

const AnimateNoteContainer = styled.div`
  & .background-enter {
    transform: translate(100%);
  }
  & .background-enter.background-enter-active {
    transform: translate(0%);
    transition: transform ${props => props.itr * 500}ms ease-in-out;
  }
  & .background-leave {
    transform: translate(0%);
  }
  .background-leave.background-leave-active {
    transform: translate(-100%);
    transition: transform ${props => props.itr * 500}ms ease-in-out;
  }

  & .background-appear {
    transform: translate(100%);
  }

  & .background-appear.background-appear-active {
    transform: translate(0%);
    transition: transform ${props => props.itr * 400}ms ease-in-out;
  }
`;

const NoteContainer = styled.div`
  display: block;
  width: 100%;
  padding: 15px 0px;
`;

const NoteContentContainer = styled.div`
  min-height: 78px;
  width: 100%;
  border-radius: 4px;
  background-color: ${props => props.theme.color.white};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  padding: 15px;
`;

const NoteHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 8px;
`;

class NotesPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: ''
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  render() {
    const {
      add,
      fetchingNotesData,
      notesData,
      close,
      isOpen,
      placeHolder
    } = this.props;

    const SidePanContents = [];

    const NotesInput = (
      <NoteInputContainer key="input">
        <EnhancedTextarea
          rows={5}
          textareaStyle={notesTextAreaStyles}
          placeholder={placeHolder}
          value={this.state.value}
          onChange={this.handleChange}
        />
        <NitroButtonGroup layout="horizontal" align="right">
          <NitroButton
            action={close}
            label="Cancel"
            size="small"
            disabled={false}
          />
          <NitroButton
            action={() => {
              const valueCopy = ` ${this.state.value}`.slice(1);
              add(valueCopy);
              this.setState({ value: '' });
            }}
            label="Add note"
            variant="secondary"
            size="small"
            disabled={!this.state.value}
          />
        </NitroButtonGroup>
      </NoteInputContainer>
    );

    const NotesList = notes => (
      <NotesListContainer key="list">
        {notes.map((note, index) => (
          <AnimateNoteContainer key={index} itr={index + 1}>
            <ReactCSSTransitionGroup
              transitionName="background"
              transitionEnterTimeout={1500}
              transitionLeaveTimeout={1500}
              transitionAppear
              transitionAppearTimeout={1500}
            >
              <NoteContainer>
                <NoteHeader>
                  <NitroText variant="secondary" bold size={14}>
                    {`${note.UserFirstName} ${note.UserSurname}`}
                  </NitroText>
                  <NitroText variant="base3" size={12}>
                    {note.DaysToolText}
                  </NitroText>
                </NoteHeader>
                <NoteContentContainer>{note.Note}</NoteContentContainer>
              </NoteContainer>
            </ReactCSSTransitionGroup>
          </AnimateNoteContainer>
        ))}
      </NotesListContainer>
    );

    if (!fetchingNotesData) {
      const header = (
        <SidePanelHeader
          drilldownTitle=""
          InsightsDrillUp={null}
          rootTitle="Notes"
          key="bookmarksHeader"
        />
      );

      // const contents = <TabsArray key="contents" data={bookMarksData} />;

      SidePanContents.push(header);
      SidePanContents.push(NotesInput);
      SidePanContents.push(NotesList(notesData));
    }

    return (
      <NitroDrawer
        isOpen={isOpen}
        close={close}
        width={450}
        padding="20px"
        iconVariant="white"
        closeIconSize={14}
      >
        {!fetchingNotesData && SidePanContents}
        {fetchingNotesData && <NitroLoading />}
        {(this.props.dataError ||
          (!fetchingNotesData && notesData && !notesData.length)) && (
          <NitroContentNotAvailable />
        )}
      </NitroDrawer>
    );
  }
}
NotesPanel.propTypes = {
  add: PropTypes.func,
  fetchingNotesData: PropTypes.bool,
  notesData: PropTypes.oneOfType([PropTypes.array, PropTypes.any, PropTypes.object]),
  title: PropTypes.string,
  isOpen: PropTypes.bool,
  close: PropTypes.func,
  placeHolder: PropTypes.string,
  author: PropTypes.string
};

NotesPanel.defaultProps = {
  // minimalMode: false
};

export default DataProvider(NotesPanel);



// WEBPACK FOOTER //
// ./src/features/dashboard/containers/NotesPanel.js